const steps = [
  {
    number: '01',
    icon: 'ri-file-list-3-line',
    title: '가족간병 등록 신청',
    desc: '아래 신청서에 간병인(가족/지인) 정보와 피보험자 정보를 입력하고 제출합니다.',
    point: '무료 등록',
  },
  {
    number: '02',
    icon: 'ri-nurse-line',
    title: '간병 시작',
    desc: '등록된 가족 또는 지인이 입원 환자를 직접 간병합니다. 간병 기간 동안 간병일지를 반드시 작성해야 합니다.',
    point: '간병일지 필수',
  },
  {
    number: '03',
    icon: 'ri-folder-upload-line',
    title: '서류 제출',
    desc: '간병 완료 후 입퇴원확인서, 간병일지, 간병인에게 간병비를 입금한 영수증을 당사에 제출합니다.',
    point: '3가지 서류',
  },
  {
    number: '04',
    icon: 'ri-file-shield-2-line',
    title: '보험 서류 발급',
    desc: '당사에서 서류를 검토한 후 보험 청구에 필요한 서류를 발급해 드립니다.',
    point: '신속 처리',
  },
];

export default function RegisterProcess() {
  return (
    <section className="w-full py-16" style={{ backgroundColor: '#f4faf8' }}>
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-semibold tracking-widest uppercase mb-2" style={{ color: '#2E7D6B' }}>HOW IT WORKS</p>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">가족간병 서비스 프로세스</h2>
          <p className="text-sm text-gray-400">등록부터 보험 서류 발급까지 4단계로 진행됩니다</p>
        </div>

        <div className="relative">
          <div
            className="hidden lg:block absolute top-[50px] h-px"
            style={{ backgroundColor: 'rgba(46,125,107,0.2)', left: '12.5%', right: '12.5%' }}
          ></div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {steps.map((step, i) => (
              <div key={i} className="flex flex-col items-center text-center">
                <div
                  className="relative w-[100px] h-[100px] flex items-center justify-center rounded-full mb-5 z-10"
                  style={{ backgroundColor: '#fff', border: '2px solid rgba(46,125,107,0.25)' }}
                >
                  <span
                    className="absolute -top-2 -right-2 w-6 h-6 flex items-center justify-center rounded-full text-white font-black"
                    style={{ backgroundColor: '#2E7D6B', fontSize: '10px' }}
                  >
                    {step.number}
                  </span>
                  <i className={`${step.icon} text-3xl`} style={{ color: '#2E7D6B' }}></i>
                </div>
                <h3 className="text-sm font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-xs leading-relaxed text-gray-500 mb-3">{step.desc}</p>
                <span
                  className="text-xs font-semibold px-3 py-1.5 rounded-full"
                  style={{ backgroundColor: 'rgba(46,125,107,0.1)', color: '#2E7D6B' }}
                >
                  {step.point}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* 필요 서류 안내 */}
        <div
          className="mt-12 rounded-2xl p-6"
          style={{ backgroundColor: '#fff', border: '1px solid rgba(46,125,107,0.2)' }}
        >
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-information-line text-lg" style={{ color: '#2E7D6B' }}></i>
            <h4 className="text-sm font-bold text-gray-900">제출 서류 안내 (간병 완료 후)</h4>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: 'ri-hospital-line', title: '입퇴원확인서', desc: '병원에서 발급받는 입퇴원 사실 확인 서류' },
              { icon: 'ri-book-2-line', title: '간병일지', desc: '간병 기간 동안 작성한 날짜별 간병 기록' },
              { icon: 'ri-receipt-line', title: '간병비 지급 영수증', desc: '간병인에게 간병비를 입금한 이체 영수증' },
            ].map((doc, i) => (
              <div key={i} className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#f4faf8' }}>
                <div className="w-9 h-9 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: 'rgba(46,125,107,0.12)' }}>
                  <i className={`${doc.icon} text-base`} style={{ color: '#2E7D6B' }}></i>
                </div>
                <div>
                  <p className="text-xs font-bold text-gray-800 mb-0.5">{doc.title}</p>
                  <p className="text-xs text-gray-500 leading-relaxed">{doc.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 text-center">
          <a
            href="#register-form"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-xl text-sm font-bold text-white whitespace-nowrap cursor-pointer hover:opacity-90 transition-opacity"
            style={{ backgroundColor: '#2E7D6B' }}
          >
            <i className="ri-arrow-up-line"></i>지금 등록 신청하기
          </a>
          <p className="text-xs text-gray-400 mt-3">
            궁금한 점은{' '}
            <a href="tel:15668654" className="font-semibold cursor-pointer" style={{ color: '#2E7D6B' }}>
              1566-8654
            </a>로 문의하세요
          </p>
        </div>
      </div>
    </section>
  );
}
